<template>
  <header :class="[isScrolled && !isMobile ? 'back-filter' : '']">
    <div class="header-container">
      <div class="header-wrap">
        <div class="header-left">
          <Logo></Logo>
        </div>
        <div class="header-right">
          <HeaderLink v-if="!isMobile"></HeaderLink>
          <Menu style="margin-left: 4px;" v-if="isMobile" @click.native="openMenu"></Menu>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Menu from "./components/menu";
import Logo from "./components/logo";
import MobileNav from "./components/mobileNav";
import HeaderLink from "./headerLink.vue";
import responsiveMixin from "@/mixins/responsive";

import Bus from "@/libs/bus";

export default {
  name: "HeaderWrap",
  mixins: [responsiveMixin],
  data() {
    return {
      isScrolled: false
    }
  },
  props: {},
  components: {
    Menu, Logo, MobileNav,
    HeaderLink
  },
  computed: {},
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      requestAnimationFrame(() => {
        this.isScrolled = window.scrollY > 0;
      });
    },
    openMenu() {
      Bus.$emit("is-open-menu", {
        slot: MobileNav, open: true, fill: "rgba(18, 17, 16, 0.7)"
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>